var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FlagContext, useFeatureFlags } from 'libs.flags.react';
import { Checkbox, FormSections, useLocalizeMessage } from 'libs.nucleus';
import { ListInformation, PageHeader, PageWrapper, } from 'libs.react';
import { ApiClientService, AuthContext, useApiClient } from 'libs.react_internal';
const isWorkspaceMomFlag = (flag) => { var _a; return ((_a = flag.extra) === null || _a === void 0 ? void 0 : _a.persistToMom) === true; };
/**
 * TODO: to be re-factorized in future once we improve the flag context to be reactive
 */
const DeveloperFlagsPage = () => {
    const translate = useLocalizeMessage();
    const navigate = useNavigate();
    const flagManager = useContext(FlagContext);
    const { entity, setEntity } = useContext(AuthContext);
    const { refreshFlags } = useFeatureFlags();
    const momClient = useApiClient(ApiClientService.MOM);
    const [flagsChanged, setFlagsChanged] = useState(false);
    const getFlagSectionName = (flag) => {
        const { extra = {} } = flag;
        return String(extra.section) || translate('General');
    };
    /**
     * We convert the flags on the flagManager to a local object as the current flag context is not reactive as needed
     */
    const getInitialFlags = () => {
        const initialFlags = flagManager.getFlags();
        return Object.keys(initialFlags).reduce((acc, name) => {
            var _a, _b, _c;
            const flag = initialFlags[name];
            if (flag.disabled) {
                return acc;
            }
            const sectionName = getFlagSectionName(flag);
            const previousSection = (_a = acc[sectionName]) !== null && _a !== void 0 ? _a : [];
            const value = isWorkspaceMomFlag(flag)
                ? ((_b = entity === null || entity === void 0 ? void 0 : entity.configuration.flagOverrides) === null || _b === void 0 ? void 0 : _b[flag.id]) === true
                : flagManager.getValue(flag);
            const updatedFlag = Object.assign(Object.assign({}, initialFlags[name]), { value });
            return Object.assign(Object.assign({}, acc), { [sectionName]: ((_c = flag.extra) === null || _c === void 0 ? void 0 : _c.isFirst) ? [updatedFlag, ...previousSection] : [...previousSection, updatedFlag] });
        }, {});
    };
    const [flagSections, setFlagSections] = useState(getInitialFlags());
    /**
     * Re-assigns all the flags to the local state adding the new value for the modified flag
     */
    const onFlagChange = (flag) => {
        setFlagsChanged(true);
        const section = getFlagSectionName(flag);
        setFlagSections((oldFlags) => (Object.assign(Object.assign({}, oldFlags), { [section]: oldFlags[section].map((sectionFlag) => sectionFlag.name === flag.name ? Object.assign(Object.assign({}, sectionFlag), { value: !sectionFlag.value }) : sectionFlag) })));
    };
    const saveFlags = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const managerFlags = flagManager.getFlags();
        const momOverrides = {};
        Object.keys(flagSections).forEach((section) => {
            flagSections[section].forEach((flag) => {
                const foundFlag = Object.keys(managerFlags).find((flagName) => managerFlags[flagName].id === flag.id);
                if (!foundFlag) {
                    return;
                }
                if (isWorkspaceMomFlag(flag)) {
                    momOverrides[flag.id] = Boolean(flag.value);
                    return;
                }
                flagManager.setValue(managerFlags[foundFlag], flag.value);
            });
        });
        if (Object.keys(momOverrides).length > 0 && (entity === null || entity === void 0 ? void 0 : entity.id)) {
            try {
                const { data: response } = yield momClient.put(`/v1/entities/${entity.id}`, {
                    name: entity.name,
                    configuration: {
                        privacyPolicy: ((_a = entity.configuration.privacyPolicy) === null || _a === void 0 ? void 0 : _a.trim()) || null,
                        flagOverrides: Object.assign(Object.assign({}, ((_b = entity.configuration.flagOverrides) !== null && _b !== void 0 ? _b : {})), momOverrides),
                    },
                });
                setEntity(response.data);
                refreshFlags();
            }
            catch (error) {
                console.error('Error updating entity flags', error);
                return;
            }
        }
        navigate(0);
    });
    const sections = useMemo(() => {
        return Object.keys(flagSections).map((section) => {
            const sectionItems = flagSections[section].map((flag) => {
                var _a;
                return ({
                    title: String(flag.name) || translate('Unnamed Flag'),
                    description: flag.description,
                    actionContent: _jsx(Checkbox, { checked: flag.value, onChange: () => onFlagChange(flag), label: '' }),
                    dataTestId: (_a = flag.extra) === null || _a === void 0 ? void 0 : _a.dataTestId,
                });
            });
            return { title: section, content: _jsx(ListInformation, { items: sectionItems }) };
        });
    }, [flagSections]);
    const headerOptions = [
        { name: translate('Save'), disabled: !flagsChanged, onClick: saveFlags, variant: 'primary' },
    ];
    return (_jsxs(PageWrapper, { children: [_jsx(PageHeader, { title: translate('Developer flags'), options: headerOptions, LinkComponent: Link }), _jsx("div", { className: 'flex flex-col h-full space-between flex-start mb-8', children: _jsx(FormSections, { sections: sections }) })] }));
};
export default DeveloperFlagsPage;
